import { render, staticRenderFns } from "./electronicView.vue?vue&type=template&id=73bb0220&scoped=true"
import script from "./electronicView.vue?vue&type=script&lang=js"
export * from "./electronicView.vue?vue&type=script&lang=js"
import style0 from "./electronicView.vue?vue&type=style&index=0&id=73bb0220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb0220",
  null
  
)

export default component.exports